import { render, staticRenderFns } from "./ProfileSelect.vue?vue&type=template&id=c073966a&"
import script from "./ProfileSelect.vue?vue&type=script&lang=js&"
export * from "./ProfileSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports